<script setup lang="ts">
  import { balanceFormat } from '@/helpers/converter'
  import { lazyLoadComponent } from '@/helpers/lazyLoadComponent'
  import { useLightBoxStore } from '@/store/LightBox'
  import { useMMStore } from '@/store/MarvelMachine'
  import { ref, watchEffect } from 'vue'
  const GamePopup = lazyLoadComponent({
    comp: () => import('@/components/MarvelMachine/MarvelGamePopup.vue'),
  })
  const lbStore = useLightBoxStore()
  const mmStore = useMMStore()
  const targetVisibility = ref(false)
  const targetAnimateShow = ref(false)
  watchEffect(() => {
    if (mmStore.game.resultOn === true) {
      targetVisibility.value = true
      setTimeout(() => {
        targetAnimateShow.value = true
        document.querySelector('.mavel-machine-main')?.classList.add('result-active')
      }, 100)
    }
    if (mmStore.game.resultOn === false) {
      targetAnimateShow.value = false
      document.querySelector('.mavel-machine-main')?.classList.remove('result-active')
      setTimeout(() => {
        targetVisibility.value = false
      }, 100)
    }
  })
  function myItems() {
    lbStore.openLightBox({
      items: [{ component: GamePopup }],
      componentProp: { content: 'myItems' },
      option: { class: 'marvel-machine-game-lightbox' },
    })
  }
</script>

<template>
  <div class="marvel-machine-result" :class="`${targetVisibility ? 'active' : ''} ${targetAnimateShow ? 'show' : ''}`">
    <div class="marvel-machine-result__content">
      <div class="marvel-machine-result__item-list">
        <MarvelResultItem
          v-for="resultItem in mmStore.game.resultItems"
          :key="resultItem.couponCode"
          :doubled-item="
            mmStore.game.resultDoubleItem.itemID == resultItem.itemID ? mmStore.game.resultDoubleItem : null
          "
          :item="resultItem"
        ></MarvelResultItem>
        <!-- <MarvelResultItem
          v-for="resultItem in mmStore.game.resultItems"
          :item="resultItem"
          :doubled="true"
          :key="resultItem.couponCode"
        ></MarvelResultItem> -->
      </div>
      <MarvelButton class="marvel-machine-result__viewcode" type="viewcode" @click="myItems()" />

      <MarvelInMessage
        v-if="mmStore.user.isTradeBlocked && !mmStore.game.nxBalanceMessageOn"
        message="tradeBlocked"
      ></MarvelInMessage>

      <div
        class="marvel-machine-result-balance"
        :class="{ active: mmStore.game.nxBalanceMessageOn, gameResetting: mmStore.game.isGameBeingResetted }"
      >
        <MarvelBoxy :type="'type1'">
          <div class="marvel-machine-result-balance__wrapper">
            <div class="marvel-machine-result-balance__previous-nx">
              Previous NX Balance: {{ balanceFormat(mmStore.marvelMachine.doubleMePrice + mmStore.user.nxBalance) }} NX
            </div>
            <div class="marvel-machine-result-balance__double-purchase">
              Double Purchase: {{ balanceFormat(mmStore.marvelMachine.doubleMePrice) }} NX
            </div>
            <div class="marvel-machine-result-balance__current-nx-balance">
              Your Current NX Balance: {{ balanceFormat(mmStore.user.nxBalance) }} NX
            </div>
          </div>
        </MarvelBoxy>
      </div>
    </div>
    <div class="marvel-machine-result__focus-bg" :class="{ active: mmStore.game.resultOn }"></div>
  </div>
</template>

<style lang="scss" scoped>
  .marvel-machine-result {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    display: none;
    z-index: 10;
    opacity: 0;
    transition: opacity 0.3s;
    color: var(--marvel-accent);
    &.active {
      display: flex;
    }
    &.show {
      opacity: 1;
    }
  }
  .marvel-machine-result__content {
    width: calc(900px * var(--marvel-desktopRatio));
    margin-top: calc(200px * var(--marvel-desktopRatio));
    position: relative;
    z-index: 2;
  }

  .marvel-machine-result__item-list {
    display: flex;
    gap: calc(20px * var(--marvel-desktopRatio));
    margin-bottom: calc(20px * var(--marvel-desktopRatio));
  }
  .marvel-machine-result__item {
    flex: 33%;
  }

  .marvel-machine-result-balance {
    position: absolute;
    left: 0;
    top: calc(370px * var(--marvel-desktopRatio));
    font-size: calc(16px * var(--marvel-desktopRatio));
    width: 100%;
    opacity: 0;
    transition: opacity 0.2s, transform 0.2s;
    &.active {
      opacity: 1;
    }
    &.gameResetting {
      transform: scale(1.1);
      opacity: 0;
    }
  }
  .marvel-machine-result-balance__wrapper {
    padding: calc(12px * var(--marvel-desktopRatio));
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-flow: column;
  }
  .marvel-machine-result-balance__double-purchase {
    margin-bottom: calc(8px * var(--marvel-desktopRatio));
    padding-bottom: calc(8px * var(--marvel-desktopRatio));
    width: calc(400px * var(--marvel-desktopRatio));
    border-bottom: 2px solid #dac9b7;
    text-align: center;
  }

  .marvel-machine-result-balance__current-nx-balance {
    font-weight: bold;
  }

  @media #{$mobileForMarvel} {
    .marvel-machine-result__content {
      width: 100%;
      margin-top: 30vw;
    }
    .marvel-machine-result {
      padding: 0 1vw;
    }
    .marvel-machine-result__item-list {
      gap: 0.7vw;
      margin-bottom: 15vw;
    }
    .marvel-machine-result__viewcode {
      position: absolute;
      left: 50%;
      top: 40vw;
      transform: translateX(-50%);
    }

    .marvel-machine-result-balance {
      top: 59vw;
      font-size: 2.1vw;
    }
    .marvel-machine-result-balance__wrapper {
      padding: 1.1vw;
    }
    .marvel-machine-result__focus-bg {
      position: absolute;
      left: 0;
      top: 14vw;
      width: 100%;
      height: 80vw;
      background: url('@/assets/imgs/mavelmachine/marvelResultItem/focus-gradient.png') no-repeat center center / 100%
        auto;
      opacity: 0;
      transition: opacity 0.3s;
      &.active {
        opacity: 1;
      }
    }
  }
</style>
